import { Box, Button, IconButton, Tooltip, useTheme } from "@mui/material";
import ChecklistIcon from "@mui/icons-material/Checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import Link from "../../atoms/mui/Link";

import SurveyStepperBar from "./SurveyStepperBar";

const SurveyHeader = ({
  percentCompleted,
  sections,
  activeSectionId,
  onOpenSummary,
  backHref = "/explorer/dashboard",
  backLabel = "Dashboard"
}) => {
  const { palette } = useTheme();
  const hasSections = Array.isArray(sections) && sections.length > 0;

  return (
    <Box
      px={{ xs: 2, md: 4 }}
      py={1.5}
      display="flex"
      alignItems="center"
      style={{
        borderBottom: `1px solid ${palette.backgroundGray.dark}`,
        gap: 16,
        flexShrink: 0
      }}
    >
      <Link href={backHref}>
        <Button
          size="small"
          startIcon={
            <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: 11 }} />
          }
          color="primary"
        >
          {backLabel}
        </Button>
      </Link>
      {hasSections ? (
        <SurveyStepperBar
          sections={sections}
          activeSectionId={activeSectionId}
        />
      ) : (
        <Box
          flexGrow={1}
          position="relative"
          style={{
            backgroundColor: palette.backgroundGray.main,
            borderRadius: "15px",
            height: "16px"
          }}
        >
          <Box
            position="absolute"
            style={{
              left: 0,
              width: `${Math.max((percentCompleted || 0) * 100, 4)}%`,
              height: "16px",
              borderRadius: "15px",
              backgroundColor: palette.secondary.main,
              transition: "width 250ms ease"
            }}
          />
        </Box>
      )}
      {onOpenSummary && (
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <Tooltip title="Your survey so far">
            <IconButton size="small" onClick={onOpenSummary}>
              <ChecklistIcon />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default SurveyHeader;
